import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DefaultContent } from '../../components/common/DefaultContent'
import { BellRinging, WarningDiamond } from '@phosphor-icons/react'
import { Body, Container, Header, Title } from './styled'
import { ActionCard } from '../../components/ActionCard'
import { OnlineEmployeesTable } from './components/OnlineEmployeesTable'

import { SideTab } from '../../components/SideTab'
import { UserStatus } from './components/UserStatus'
import api from '../../services/api'

import { Helmet } from 'react-helmet'

interface IEmployee {
  occurrences: {
    code: string
    status: string
    type?: string
  }[]
}

export const OnlineEmployees = () => {
  const navigate = useNavigate()
  const [openStatus, setOpenStatus] = useState<boolean>(false)
  const [occurrencesCount, setOccurrencesCount] = useState(0)
  const [employeeInfo, setEmployeeInfo] = useState<IEmployee[]>([])

  const [editData, setEditData] = useState()

  console.log('🚀 ~ file: index.tsx:38 ~ OnlineEmployees ~ editData:', editData)

  useEffect(() => {
    api
      .get('/v1/dashboard/surveillance/employees')
      .then((response) => {
        console.log(response.data)
        setEmployeeInfo(response.data)
        // console.log(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  useEffect(() => {
    api
      .get('/v1/dashboard/surveillance/occurrences/count')
      .then((response) => {
        console.log(response.data)
        setOccurrencesCount(response.data)
        // console.log(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  function findById(user, id) {
    return user.find((item) => item.id === id)
  }

  const handler = (id) => {
    const result = findById(employeeInfo, id)
    // localStorage.setItem('mykey', { result })
    console.log('🚀 ~ file: index.tsx:43 ~ handler ~ result:', result)
    setEditData(result)
    setOpenStatus((prev) => !prev)
  }

  return (
    <>
      <Helmet>
        <title>Previx - Funcionários online</title>
        <meta
          name="Previx - Funcionários online"
          content="Página de funcionários online"
        />
      </Helmet>
      <DefaultContent
        title="Previx - Vigilância - Funcionários online"
        icon={<BellRinging size={36} color="#003E5F" weight="bold" />}
      >
        <Container>
          <Header>
            <ActionCard.Root>
              <ActionCard.Content
                background="#00517D"
                border="#003E5F"
                color="#fff"
                onclick={() => navigate('/vigilancia/ultimas-ocorrencias')}
              >
                <ActionCard.Icon
                  transform={0}
                  icon={
                    <WarningDiamond size={60} weight="fill" color="#EDF4FC" />
                  }
                />
                <ActionCard.Information value="Ultimas ocorrências" />
                <ActionCard.Notification value={occurrencesCount} />
              </ActionCard.Content>
            </ActionCard.Root>
          </Header>
          <Body>
            <Title>Lista de usuários cadastrados na plataforma</Title>
            <OnlineEmployeesTable onclick={handler} data={employeeInfo} />
          </Body>
        </Container>
      </DefaultContent>

      <SideTab
        title="Status de usuário"
        open={openStatus}
        toggleFunction={() => setOpenStatus((prev) => !prev)}
      >
        <UserStatus data={editData} />
      </SideTab>
    </>
  )
}
